import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio2To120(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectRatio2To120"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1M1 4.5A2.5 2.5 0 0 1 3.5 2h6A2.5 2.5 0 0 1 12 4.5v11A2.5 2.5 0 0 1 9.5 18h-6A2.5 2.5 0 0 1 1 15.5zm12.96-.75a.75.75 0 0 1 .75-.75h3.613a.75.75 0 0 1 0 1.5H14.71a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h3.613a.75.75 0 0 1 0 1.5H14.71a.75.75 0 0 1-.75-.75M14.71 6a.75.75 0 0 0 0 1.5h2.416a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h2.416a.75.75 0 0 1 0 1.5H14.71a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio2To120);
